import image1 from "../Assets/project- (1).JPG";
import image2 from "../Assets/project- (2).JPG";
import image3 from "../Assets/project- (3).JPG";
import image4 from "../Assets/project- (4).jpg";
import image5 from "../Assets/project- (5).jpg";
import image6 from "../Assets/project- (6).jpg";
import image7 from "../Assets/project- (7).jpg";
import image8 from "../Assets/project- (8).jpg";
import image9 from "../Assets/project- (9).jpg";
import image10 from "../Assets/project- (10).jpg";
import image11 from "../Assets/project- (11).jpg";
import image12 from "../Assets/project- (12).jpg";
import image13 from "../Assets/project- (13).jpg";
import image14 from "../Assets/project- (14).jpg";
import image15 from "../Assets/project- (15).jpg";
import image16 from "../Assets/project- (16).jpg";
import image17 from "../Assets/project- (17).jpg";
import image18 from "../Assets/project- (18).jpg";
import image19 from "../Assets/project- (19).jpg";
import image20 from "../Assets/project- (20).jpg";
import image21 from "../Assets/project- (21).jpg";
import image22 from "../Assets/project- (22).jpg";
import image23 from "../Assets/project- (23).jpg";
import image24 from "../Assets/project- (24).jpg";
// import image25 from "../Assets/project- (25).jpg";
// import image26 from "../Assets/project- (26).jpg";
// import image27 from "../Assets/project- (27).jpg";
// import image28 from "../Assets/project- (28).jpeg";
import image29 from "../Assets/project- (29).jpg";
import image30 from "../Assets/project- (30).jpg";
import image31 from "../Assets/project- (31).jpg";

const worksData = [
  // {
  //   id: 28,
  //   firstImage: image28,
  //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  //   fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  // },
  // {
  //   id: 27,
  //   firstImage: image27,
  //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  //   fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  // },
  // {
  //   id: 26,
  //   firstImage: image26,
  //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  //   fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  // },
  // {
  //   id: 25,
  //   firstImage: image25,
  //   description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
  //   fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  // },
  {
    id: 1,
    firstImage: image1,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 2,
    firstImage: image2,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 3,
    firstImage: image3,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 4,
    firstImage: image4,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 5,
    firstImage: image5,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 6,
    firstImage: image6,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 7,
    firstImage: image7,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 8,
    firstImage: image8,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 9,
    firstImage: image9,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 10,
    firstImage: image10,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 11,
    firstImage: image11,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 12,
    firstImage: image12,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 13,
    firstImage: image13,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 14,
    firstImage: image14,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 15,
    firstImage: image15,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 16,
    firstImage: image16,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 17,
    firstImage: image17,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 18,
    firstImage: image18,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 19,
    firstImage: image19,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 20,
    firstImage: image20,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 21,
    firstImage: image21,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 22,
    firstImage: image22,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 23,
    firstImage: image23,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 24,
    firstImage: image24,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 29,
    firstImage: image29,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 30,
    firstImage: image30,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
  {
    id: 31,
    firstImage: image31,
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    fullText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam...'
  },
];

export { worksData };